<template>
  <b-container class="py-5">
    <h2 class="font-weight-bold mb-4"><span class="text-primary">마이페이지</span> / 계정 관리</h2>

    <b-row v-if="loading" class="py-5 text-center">
      <b-col>
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </b-col>
    </b-row>

    <b-row v-else>
      <b-col md="7">
        <b-card title="기본 정보 수정" class="border-0 shadow-sm rounded-lg mb-4">
          <b-form @submit.prevent="updateProfile">
            <b-form-group label="아이디" label-class="small text-muted font-weight-bold">
              <b-form-input v-model="form.username" readonly class="bg-light"></b-form-input>
              <small class="text-muted">아이디는 변경할 수 없습니다.</small>
            </b-form-group>

            <b-form-group label="이름" label-class="small text-muted font-weight-bold">
              <b-form-input v-model="form.name" required placeholder="성함을 입력하세요"></b-form-input>
            </b-form-group>

            <b-form-group label="새 비밀번호" label-class="small text-muted font-weight-bold">
              <b-form-input v-model="form.password" type="password" placeholder="변경할 경우에만 입력하세요"></b-form-input>
            </b-form-group>

            <div class="text-right mt-4">
              <b-button type="submit" variant="primary" class="px-5 rounded-pill font-weight-bold">정보 수정 저장</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>

      <b-col md="5">
        <b-card title="인감 도장 관리" class="border-0 shadow-sm rounded-lg">
          <div class="text-center p-4">
            <div class="stamp-preview-container mb-4 mx-auto">
              <img v-if="form.stampImage" :src="form.stampImage" class="stamp-img"/>
              <div v-else class="no-stamp"><span>미등록</span></div>
              <div class="stamp-overlay-text">인</div>
            </div>

            <p class="small text-muted mb-4">배경이 투명한 PNG/SVG를 권장합니다.</p>

            <input type="file" ref="fileInput" accept="image/png, image/svg+xml" style="display: none"
                   @change="onFileChange">
            <b-button variant="outline-primary" block @click="$refs.fileInput.click()">도장 이미지 선택</b-button>
            <b-button v-if="form.stampImage" variant="link" class="text-danger mt-2 small"
                      @click="form.stampImage = ''">이미지 삭제
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// import axios from 'axios';

export default {
  name: 'MyPage',
  data() {
    return {
      loading: true,
      form: {
        username: '',
        name: '',
        password: '',
        stampImage: ''
      }
    };
  },
  async created() {
    // 페이지 접속 시 정보를 먼저 불러옵니다.
    await this.loadUserData();
  },
  methods: {
    async loadUserData() {
      this.loading = true;
      try {
        const res = await this.$axios.get('/api/auth/me');

        // 백엔드 응답 구조가 { status, message, data: { ... } } 이므로
        // res.data.data를 가져와야 합니다.
        if (res.data && res.data.status === "success") {
          const userData = res.data.data;

          // 중요: 기존 form 객체의 속성들에 하나씩 할당하여 반응성을 유지합니다.
          this.form.username = userData.username;
          this.form.name = userData.name;
          this.form.stampImage = userData.stampImage || '';

          console.log("데이터 매핑 완료:", this.form);
        }
      } catch (e) {
        console.error("사용자 정보 로드 실패", e);
      } finally {
        this.loading = false;
      }
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (event) => {
        this.form.stampImage = event.target.result;
      };
      reader.readAsDataURL(file);
    },
    async updateProfile() {
      try {
        const res = await this.$axios.post('/api/auth/updateProfile', this.form);
        if (res.status === 200) {
          alert('정보가 수정되었습니다.');
          this.form.password = ''; // 비밀번호 필드 초기화
        }
      } catch (e) {
        alert('수정 중 오류가 발생했습니다.');
      }
    }
  }
}
</script>

<style scoped>
.stamp-preview-container {
  width: 120px;
  height: 120px;
  border: 2px dashed #ddd;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #fcfcfc;
}

.stamp-img {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  z-index: 2;
}

.stamp-overlay-text {
  position: absolute;
  font-size: 40px;
  color: rgba(255, 0, 0, 0.1);
  font-weight: bold;
  z-index: 1;
}

.no-stamp {
  color: #ccc;
}
</style>
